import { useBackHandlerContext } from '@context/BackHandler';
import { useVideoCallContext } from '@context/VideoCall';
import { FocusContext, useFocusable } from '@noriginmedia/norigin-spatial-navigation';
import { useEffect, useLayoutEffect } from 'react';

import Video from './components/Video';
import VideoFooter from './components/VideoFooter';

import * as styles from './styles';

const VideoCall = () => {
  const { setButtonFocus } = useVideoCallContext();

  const { disableBack } = useBackHandlerContext();

  useLayoutEffect(() => {
    return disableBack();
  }, [disableBack]);

  const { focusKey } = useFocusable();

  useEffect(() => {
    setButtonFocus();
  }, [setButtonFocus]);

  return (
    <FocusContext.Provider value={focusKey}>
      <div css={styles.container}>
        <Video />
        <VideoFooter />
      </div>
    </FocusContext.Provider>
  );
};

export default VideoCall;
